import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ActivityType;
(function (ActivityType) {
    ActivityType["Login"] = "Login";
    ActivityType["UserCreated"] = "User created";
    ActivityType["UserUpdated"] = "User updated";
    ActivityType["UserDeleted"] = "User deleted";
    ActivityType["PayoutRuleCreated"] = "Payout rule created";
    ActivityType["PayoutRuleUpdated"] = "Payout rule updated";
    ActivityType["PayoutRuleDeleted"] = "Payout rule deleted";
    ActivityType["RuleOverrideCreated"] = "Rule override created";
    ActivityType["RuleOverrideUpdated"] = "Rule override updated";
    ActivityType["RuleOverrideDeleted"] = "Rule override deleted";
    ActivityType["InvoiceCreated"] = "Invoice created";
    ActivityType["InvoiceDeleted"] = "Invoice deleted";
    ActivityType["ClickHiddenUnhidden"] = "Click hidden/unhidden";
    ActivityType["TestClickStatusUpdated"] = "Test click status updated";
    ActivityType["AffiliateAPITokenUpdated"] = "Affiliate API token updated";
    ActivityType["TwoFAGlobalSettingChanged"] = "2FA global setting changed";
    ActivityType["User2FAReset"] = "User 2FA reset";
})(ActivityType || (ActivityType = {}));
export const ActivityTypeMap = new Map([
    [ActivityType.Login, 'Global.Text.Login'],
    [ActivityType.UserCreated, 'Global.Options.UserCreated'],
    [ActivityType.UserUpdated, 'Global.Options.UserUpdated'],
    [ActivityType.UserDeleted, 'Global.Options.UserDeleted'],
    [ActivityType.PayoutRuleCreated, 'Global.Options.PayoutRuleCreated'],
    [ActivityType.PayoutRuleUpdated, 'Global.Options.PayoutRuleUpdated'],
    [ActivityType.PayoutRuleDeleted, 'Global.Options.PayoutRuleDeleted'],
    [ActivityType.RuleOverrideCreated, 'Global.Options.RuleOverrideCreated'],
    [ActivityType.RuleOverrideUpdated, 'Global.Options.RuleOverrideUpdated'],
    [ActivityType.RuleOverrideDeleted, 'Global.Options.RuleOverrideDeleted'],
    [ActivityType.InvoiceCreated, 'Global.Options.InvoiceCreated'],
    [ActivityType.InvoiceDeleted, 'Global.Options.InvoiceDeleted'],
    [ActivityType.ClickHiddenUnhidden, 'Global.Options.ClickHiddenUnhidden'],
    [ActivityType.TestClickStatusUpdated, 'Global.Options.TestClickStatusUpdated'],
    [ActivityType.AffiliateAPITokenUpdated, 'Global.Options.AffiliateAPITokenUpdated'],
    [ActivityType.TwoFAGlobalSettingChanged, 'Global.Options.TwoFAGlobalSettingChanged'],
    [ActivityType.User2FAReset, 'Global.Options.User2FAReset'],
]);
let ActivityTypesService = class ActivityTypesService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ActivityTypeMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
ActivityTypesService.ctorParameters = () => [
    { type: TranslateService }
];
ActivityTypesService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ActivityTypesService);
export { ActivityTypesService };
